module.exports = __webpack_public_path__ + "static/media/prev-arrow.1339794e.svg";